import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import * as types from './mutation-types';

export function setCards({ commit }, cards) {
  commit(types.SET_CARDS, cards);

  return Promise.resolve(cards);
}

export function setCardsPagination({ commit }, pagination) {
  commit(types.SET_PAGINATION, pagination);

  return Promise.resolve(pagination);
}

export function fetchCards({ dispatch, getters }) {
  const params = getters.getRouteQuery;

  return http.get(`${MINERVA_API_URL}/assignments`, { params })
    .then((resp) => {
      dispatch('setCards', resp.data);
      dispatch('setCardsPagination', {
        total: Number(resp.headers.total),
        perPage: Number(resp.headers['per-page']),
      });
    });
}

export function setCard({ commit }, card) {
  commit(types.SET_CARD, card);

  return Promise.resolve(card);
}

export function fetchCard({ dispatch }, id) {
  return http.get(`${MINERVA_API_URL}/assignments/${id}`)
    .then(resp => dispatch('setCard', resp.data))
    .catch(err => Promise.reject(err));
}

export function setCoreConcept({ commit }, coreConcept) {
  commit(types.SET_CORECONCEPT, coreConcept);

  return Promise.resolve(coreConcept);
}

export function fetchCoreConcept({ dispatch }, coreConceptId) {
  return http.get(`${MINERVA_API_URL}/core-concepts/${coreConceptId}`)
    .then(resp => dispatch('setCoreConcept', resp.data))
    .catch(err => Promise.reject(err));
}
